import React from 'react';

const AppSkeleton = ({
  shape = 'rectangle', // 'rectangle', 'circle'
  width = '100%',
  height = '1rem',
  className = '',
  ...rest
}) => {
  const isCircle = shape === 'circle';
  
  return (
    <div
      className={`skeleton ${isCircle ? 'rounded-full' : 'rounded-md'} ${className}`}
      style={{
        width: width,
        height: height,
        minWidth: isCircle ? height : undefined, // ensures circle shape if width is missing
      }}
      {...rest}
    ></div>
  );
};

export default AppSkeleton;
